<template>
  <div class="ag-input-text-wrapper">
    <input ref="eFloatingFilterText" :value="currentValue" type="text" @input="valueChanged" />

    <q-icon color="tertiary" size="1.1rem" name="fas fa-info-circle">
      <LmTooltip>
        Type a year "2016", "2017" <br />
        Type a specific date in CUSTOM format, so "12/31/2019" (MM/DD/YYYY) or "31/12/2019" (DD/MM/YYYY) <br />
        Type a range in CUSTOM format "01/01/2019..12/31/2019" OR "01/01/2019..31/12/2019" by using two dots between two
        dates
      </LmTooltip>
    </q-icon>
  </div>
</template>

<script>
import Vue from 'vue'
import { debounce } from 'lodash'

export default Vue.extend({
  data: function() {
    return {
      currentValue: null
    }
  },

  created() {
    this.valueChanged = debounce(
      function(event) {
        const value = event.target.value
        this.params.parentFilterInstance(function(instance) {
          instance.onFloatingFilterChanged('equals', value)
        })
      }.bind(this),
      this.params.debounceMs
    )
  },

  methods: {
    onParentModelChanged(parentModel) {
      this.currentValue = !parentModel ? null : parentModel.filter ? parentModel.filter : null
    },

    buildModel() {
      if (!this.currentValue) return null
      return {
        filterType: 'text',
        type: 'equals',
        filter: this.currentValue,
        filterTo: null
      }
    }
  }
})
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.ag-input-text-wrapper {
  padding 0
}

input {
  width calc(100% - 5px)
  border 1px solid $light-grey
  border-radius 5px
  margin 0 !important
  padding 5px
  height 30px

  &:focus {
    border-bottom: 2px solid $primary !important;
  }
}

i {
  position absolute
  top 10%
  right 2%
}
</style>
